import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../../components/Modal';
import MembershipSettingPresenter from '../../../../presenters/MembershipSettingPresenter';

import EditSettingForm from './components/EditSettingForm';

const EditSettingModal = (props) => {
  const {
    onEditDialogClose,
    isEditDialogOpen,
    onSubmit,
    apiErrors,
    currentMembershipSetting,
  } = props;

  return (
    <Modal
      title="Edit Membership Setting"
      onClose={onEditDialogClose}
      isModalOpen={isEditDialogOpen}
    >
      <EditSettingForm
        onModalClose={onEditDialogClose}
        onSubmit={onSubmit}
        apiErrors={apiErrors}
        currentMembershipSetting={currentMembershipSetting}
      />
    </Modal>
  );
};

export default EditSettingModal;

EditSettingModal.propTypes = {
  onEditDialogClose: PropTypes.func.isRequired,
  isEditDialogOpen: PropTypes.bool.isRequired,
  currentMembershipSetting: MembershipSettingPresenter.shape().isRequired,
  onSubmit: PropTypes.func.isRequired,
  apiErrors: PropTypes.shape(),
};

EditSettingModal.defaultProps = {
  apiErrors: {},
};
